import { render, staticRenderFns } from "./ZBJZFSQB.vue?vue&type=template&id=8e008ff8&scoped=true"
import script from "./ZBJZFSQB.vue?vue&type=script&lang=js"
export * from "./ZBJZFSQB.vue?vue&type=script&lang=js"
import style0 from "./ZBJZFSQB.vue?vue&type=style&index=0&id=8e008ff8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e008ff8",
  null
  
)

export default component.exports